import type { ReactNode } from 'react';

export const symbol_plane_contrails: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M350-101q-9-9-9-21.5t9-21.5l131-131q9-9 21-9t21 9q9 9 9 21.5t-9 21.5L392-101q-9 9-21 9t-21-9Zm206 0q-9-9-9-21t9-21l111-111q9-9 21.5-9t21.5 9q9 9 9 21t-9 21L599-101q-9 9-21.5 9t-21.5-9ZM101-556q-9-9-9-21t9-21l111-111q9-9 21.5-9t21.5 9q9 9 9 21.5t-9 21.5L144-555q-9 9-21.5 8.5T101-556Zm1 207q-9-9-9-21.5t9-21.5l131-131q9-9 21-9t21 9q9 9 9 21.5t-9 21.5L144-349q-9 9-21 9t-21-9Zm391-144-98-55q-9-5-9.5-15.5T398-587q4-4 9-5.5t10-.5l87 18 97-97-212-85q-12-5-14.5-18t7.5-22l8-8q4-4 10-5.5t11-.5l285 45 98-99q7-7 16-10.5t19-3.5q10 0 19 3.5t17 11.5q8 7 11.5 16t3.5 18q0 10-4 19t-12 17l-98 98 45 284q1 6-.5 12t-6.5 11l-3 3q-11 11-25.5 8T755-395l-83-206-97 98 17 85q2 6 0 11.5t-9 12.5q-8 8-19.5 6.5T546-399l-53-94Z"
		/>
	</svg>
);
